import { APIProvider } from '@vis.gl/react-google-maps';

const API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

export function GoogleMapsApiProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <APIProvider apiKey={API_KEY}>{children}</APIProvider>;
}
